import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import { useLocation, useNavigate, useParams } from "react-router-dom";

import { Typography } from "@mui/material";

import { useLegacyEffect } from "helper/customHook";
import { ReduxStateType } from "redux-store/types";

import Report from "modules/ResearchReport/Pages/Main/component/report";
import { LASTEST_TAB } from "modules/ResearchReport/const";
import {
  getListResearchReportStart,
  resetGetListResearchReport,
} from "modules/ResearchReport/redux/getListResearchReport";
import {
  listResearchReportDataSelector,
  listResearchReportStatusSelector,
} from "modules/ResearchReport/redux/selector";

import ListInfinitiveScrolling from "components/common/ListInfinitiveScrolling";
import { resetControlPage } from "components/common/ListInfinitiveScrolling/redux/controlInfinitiveScrolling";
import {
  Footer,
  ListOtherReport,
  OtherReportTitle,
  OtherReportWrapper,
} from "../styles";
import pxToRem from "theme/base/pxToRem";

const OtherReport = () => {
  const { tab, id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const listOtherReport = useSelector(listResearchReportDataSelector);
  const status = useSelector(listResearchReportStatusSelector);

  const payload = useMemo(() => {
    return {
      nodeId: tab === LASTEST_TAB ? "" : tab,
      idNews: tab === LASTEST_TAB,
    };
  }, [tab]);

  const baseUrl = location.pathname.replace(`/${id}`, "");

  useLegacyEffect(() => {
    dispatch(getListResearchReportStart(payload));
    return () => {
      dispatch(resetControlPage(null));
      dispatch(resetGetListResearchReport());
    };
  }, [tab]);

  const loadMoreData = () => {
    if (status !== ReduxStateType.LOADING) {
      dispatch(getListResearchReportStart(payload));
    }
  };

  return (
    <OtherReportWrapper>
      <OtherReportTitle>Các báo cáo khác</OtherReportTitle>
      <ListOtherReport>
        {listOtherReport.length > 0 && (
          <ListInfinitiveScrolling
            data={listOtherReport}
            fetchMoreData={loadMoreData}
            style={{ margin: pxToRem(-10), padding: pxToRem(10) }}
          >
            {({ index }) => {
              return (
                <Report
                  reportContent={listOtherReport[index]}
                  status={status}
                  index={index}
                />
              );
            }}
          </ListInfinitiveScrolling>
        )}
      </ListOtherReport>
      <Footer>
        <Typography
          variant="subtitle1"
          fontWeight={600}
          onClick={() => navigate(baseUrl)}
          sx={({ palette }) => ({
            cursor: "pointer",
            color: palette.colorsBase.blue_0,
          })}
        >
          Xem tất cả
        </Typography>
      </Footer>
    </OtherReportWrapper>
  );
};

export default OtherReport;
